import ReactOnRails from 'react-on-rails';
import ConsentPage from '../src/components/consent';
import LoginPage from '../src/components/login';
import DeviceAuth from '../src/components/device-auth';
import App from '../src/components/app';
import '../src/cable/logout_channel';

// Client side rendered components
ReactOnRails.register({
  ConsentPage
});
ReactOnRails.register({
  LoginPage
});
ReactOnRails.register({
  DeviceAuth
});
ReactOnRails.register({
  App
});
